import { QrPreviewComponent } from './qr-preview/qr-preview.component';

import { UploadButton } from './upload-button/upload-button.component';

import { FolderList } from './folder-list/folder-list.component';

import Header from '../components/Header';

import './app.scss';

function App() {
	return (
		<>
			<Header />
			<div id="wrapper" className="wrapper">
			<div>
				<UploadButton />
				<FolderList />
			</div>
			<div>
				<QrPreviewComponent />
			</div>
		</div>
		</>
	);
}

export default App;
